/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_About_Blurb1Inputs */

const vi_sitesettings_brand_about_blurb1 = /** @type {(inputs: Sitesettings_Brand_About_Blurb1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giới thiệu ngắn (Mini App trang chủ)`)
};

/**

* @param {Sitesettings_Brand_About_Blurb1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_about_blurb1 = /** @type {((inputs?: Sitesettings_Brand_About_Blurb1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_About_Blurb1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_about_blurb1(inputs)
});
export { sitesettings_brand_about_blurb1 as "siteSettings_brand_about_blurb" }